import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import styled from 'styled-components'
import userIconBlue from '../assets/account-blue.png'
import userIconWhite from '../assets/account-white.png'

const Nav = styled.div`
  background-color: #204051;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 50px;
  padding: 0 0 0 15px;
  margin: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  z-index: 2;
  box-sizing: border-box;
  color: #fff;
`
const DivBoxShadow = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 50px;
  box-shadow: 0px 0px 5px 0px rgb(222,222,222);
`

const InfosUser = styled.div`
  display: flex;
  align-items: center;
  padding: 0 60px 0 15px;
  height: 50px;
  transition: 0.3s;
  width: 120px;
  background-image: url(${userIconWhite});
  background-size: 30px;
  background-repeat: no-repeat;
  background-position: 90% 50%;
  
  :hover {
    background-color: #fff;
    cursor: pointer;
    color: #204051;
    background-image: url(${userIconBlue});
  }
`

const PrenomNom = styled.p`
  font-weight: bold;
  text-transform: uppercase;
`

const Title = styled.span`
  font-weight: bolder;
  font-size: 28px;
  cursor: pointer;
`

const Navbar = () => {
    const [data, setDataUser] = useState([])
    const history = useHistory()
    const token = localStorage.getItem('token')

    useEffect(() => {
        const fetchData = async () => {
            const local = JSON.parse(JSON.parse(localStorage.getItem('persist:3fts')).login)
            const user = {
                prenom: await local.prenom,
                nom: await local.nom
            }
            setDataUser(user)
        }
        fetchData()
    }, [])

    return (
        <>
            <DivBoxShadow/>
            <Nav>
                {
                    localStorage.getItem('admin') ?
                        <Title onClick={() => history.push('/dashboard')}>
                            LICENCES 3FTS
                        </Title> :
                        <Title onClick={() => history.push(`/club/${localStorage.getItem('idClub')}`)}>
                            LICENCES 3FTS
                        </Title>
                }
                {
                    token !== "guest" ?
                        <InfosUser onClick={() => history.push('/profile')}>
                            <PrenomNom>{data.prenom} {data.nom}</PrenomNom>
                        </InfosUser>
                        : null
                }
            </Nav>
        </>
    )
}

export default Navbar
